export function getPayorName(payor) {
  if (payor.person) {
    return `${payor.person.first_name} ${payor.person.last_name}`
  } else {
    return payor.is_primary ? '[Primary payor]' : '[Secondary payor]'
  }
}
